'use client';

import type { ReactNode } from 'react';
import { useTranslations } from 'next-intl';
import { Button, MetaDefault } from '@terra/ui-design-system';
import { HStack } from '@terra/ui-styled-system';

export function ListPageSelectionBar({
  selectedCount,
  clearSelectionLabel,
  onClearSelection,
  children,
}: {
  selectedCount: number;
  clearSelectionLabel: string;
  onClearSelection: () => void;
  children: ReactNode;
}) {
  const tCommon = useTranslations('common');

  return (
    <HStack gap="1" alignItems="center" flexShrink={0}>
      <MetaDefault color="fg.default" whiteSpace="nowrap" pl="1">
        {tCommon('selectedCount', { count: selectedCount })}
      </MetaDefault>
      <Button
        size="xs"
        variant="ghost"
        h="6"
        px="1.5"
        onClick={onClearSelection}
      >
        {clearSelectionLabel}
      </Button>
      <HStack gap="0.5" alignItems="center" flexShrink={0}>
        {children}
      </HStack>
    </HStack>
  );
}
